import storeConfig from 'Stores/valvetronic-designs/config';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
  import('Diagnostics/diagnostics')
    .then(({ logRuntimeError }) => logRuntimeError({ source: 'init_func', error: e }))
    .catch(() => {});
}
